export const idlFactory = ({ IDL }) => {
  return IDL.Service({
    'search_query' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Float32), IDL.Nat32],
        [IDL.Text],
        [],
      ),
    'search_query_v2' : IDL.Func(
        [IDL.Text, IDL.Vec(IDL.Float32), IDL.Nat32],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)), IDL.Text],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
